import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import styles from "./WordCount.css";

import calculateWordCount from "editor/utils/calculateWordCount";
import isEditorActive from "editor/utils/isEditorActive";

export default function WordCount({
  editorState,
  multiEditorBlockComposition,
}) {
  // Calculate the total word count if this is a story, or the word count for
  // the selected chunk if this is a newsletter.
  const wordCount = calculateWordCount(editorState);

  // "multiEditorBlockComposition" will only be defined for newsletters, and
  // consists of a Draft.js EditorState with the complete newsletter in it. If
  // it's been provided, use that to calculate the total word count for the
  // newsletter.
  const newsletterTotalCount = multiEditorBlockComposition
    ? calculateWordCount(multiEditorBlockComposition)
    : null;

  const className = classNames(styles.root, {
    [styles.hidden]: !isEditorActive(editorState),
  });

  return (
    <div className={className}>
      <p>{`${wordCount} word${wordCount === 1 ? "" : "s"}`}</p>
      <p>
        {typeof newsletterTotalCount === "number" &&
          `${newsletterTotalCount} word${
            newsletterTotalCount === 1 ? "" : "s"
          } total`}
      </p>
    </div>
  );
}

WordCount.propTypes = {
  editorState: PropTypes.object.isRequired,

  // only passed in to props if this is a newsletter
  multiEditorBlockComposition: PropTypes.object,
};
